import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import BodyTextLarge from 'Components/ComponentLibrary/Atoms/Text/BodyTextLarge';

export const metaOverrideSet = fr.metaOverride({ BaseOverrideNoHidden })
  .overrideAll({
    readonly: true,
    _component: () => BodyTextLarge,
  }, { ordinal: 200 })
  .typeOverride('bool', {
    _formatReadOnly: () => (v) => {
      if (v === 'true') {
        return 'Yes';
      }
      return 'No';
    },
  }, { ordinal: 200 });
